// ******************  if needed we can use this ******************
// ============================================================================================

// enum PROGRAM_CODE => DRP | DCP | NTC | OTHERS | DEP
// enum ExperianAccountType => Unsecured | Secured
// enum CREDIT_BUREAU => EXPERIAN | CIBIL | CRIF
// enum CREDIT_PULL_VENDOR => EXPERIAN |  DIGITAP 
// enum REPORT_FORMAT_TYPE => EXPERIAN  
// enum GENDER => MALE | FEMALE | OTHER
// enum DEBT_TYPE => PERSONAL_LOAN ("Personal Loan") | CREDIT_CARD ("Credit Card")
// enum SOURCE => ICC | CREDIT_INSIGHT | SPINE | HELIX
// enum TEMPLATE => FREED_CREDIT_REPORT
// enum JOLT_VERSION => v1
// enum CREDIT_REPORT_ACCOUNT_TYPE => UNSECURED("Unsecured") | SECURED("Secured") | OTHERS("Others")
// enum CREDIT_REPORT_ACCOUNT_STATUS => ACTIVE("Active") |  CLOSED("Closed")
// enum CREDIT_REPORT_DEBT_TYPE => CREDIT_CARD("CreditCard") | PERSONAL_LOAN("Personal Loan") | BUSINESS_LOAN("Business Loan") | CONSUMER_LOAN("Consumer Loan") | TEMPORARY_OVERDRAFT("Temorary Overdraft") | OTHERS("Others") | AUTO_LOAN("Auto Loan") | HOUSING_LOAN("Housing Loan") | PROPERTY_LOAN("Property Loan")
// enum CREDIT_REPORT_PROCESSING_STATUS => RECEIVED | PROCESSING |  PROCESSED | FAILED 
// enum CREDIT_REPORT_MODE  => WEBHOOK | API
// enum CREDIT_REPORT_CONSENT_STATUS => PENDING | ACTIVE | REVOKED | EXPIRED | COMPLETED
// enum CREDIT_REPORT_CONSENT_TYPE => MULTI_USE | SUBSCRIPTION
// enum CREDIT_REPORT_PULL_TYPE => MULTI_USE | SUBSCRIPTION



// ********* All enums ********* 
export enum CREDIT_REPORT_ACCOUNT_STATUS {
    ACTIVE = "ACTIVE",
    CLOSED = "CLOSED"
}

export enum CREDIT_REPORT_ACCOUNT_TYPE {
    UNSECURED = "UNSECURED",
    SECURED = "SECURED",
    OTHERS = "OTHERS"
}


//  ********* All dataTypes ********* 
export interface FFCreditReportData {
    version: string,
    creditBureauScore: number,
    creditBureau: string,
    panList: String[],
    bureauReportedDate: string,
    accountInfo: FFAccountInfo[],
    accountHolderAddressList: FFAccountHolderAddress[],
    accountHolderInfoList: FFAccountHolderInfo[],
    accountsSummary: FFAccountsSummary,
    enquiryList: FFInquiry[],
    preprocessed_accountInfo?: PreprocessedData;             // for FE purpose
    accountHolderFullName?: string,                          // for FE purpose

}


export interface FFInquiry {
    enquiryReason: string,
    financePurpose: number,
    amountFinanced: Number
}


export interface FFAccountInfo {
    lenderName: string,
    accountNumber: string,
    accountStatus: CREDIT_REPORT_ACCOUNT_STATUS,
    accountType: CREDIT_REPORT_ACCOUNT_TYPE,
    debtType: string,
    accountHistoryList: FFAccountHistoryData[],
    accountHolderAddressList: FFAccountHolderAddress[],
    accountHolderInfoList: FFAccountHolderInfo[],
    accountHolderIdentityList: FFAccountHolderIdentity[],
    creditLimitAmount?: number,
    sanctionedAmount: number,
    outstandingAmount: number,
    overdueAmount?: number,
    settlementAmount: number,
    additionDate: string,
    closedDate?: string,
    reportedDate?: string,
    lastPaymentDate?: string,
    openDate?: string,
    roi?: number,
    repaymentTenure?: number,
    tenureCovered?: number,
    tenureWithNoDPD?: number,
    tenureWithDPD?: number,
    lastTenureWithNoDPD?: number,
    lastTenureWithDPD?: number,
    delinquency: number,
    delinquencyRule: string,
    suitFiledWillfulDefaultWrittenOffStatus?: string,
    suitFiledWilfulDefault?: String
    Preprocessed_Payment_History?: PreprocessedHistory[];     // for FE purpose
    NumberOfOnTimePayments?: number;                          // for FE purpose
    NumberOfMissedPayments?: number;                          // for FE purpose
}

export interface FFAccountHistoryData {
    assetCategory?: string,
    daysPastDue: number,
    month: number,
    year: Number
}

export interface FFAccountHolderAddress {
    addressLine1?: string,
    addressLine2?: string,
    addressLine3?: string,
    state: string,
    city?: string,
    zipCode: Number
}

export interface FFAccountHolderIdentity {
    pan?: String
}

export interface FFAccountHolderInfo {
    firstName: string,
    dateOfBirth?: string,
    gender?: string,
    middleName1?: string,
    middleName2?: string,
    lastName?: string,
    mobile?: string,
}

export interface FFAccountsPerformanceSummary {
    performanceSummaryLast180Days: number,
    performanceSummaryLast30Days: number,
    performanceSummaryLast7Days: number,
    performanceSummaryLast90Days: Number
}

export interface FFAccountsSummary {
    accountsPerformanceSummary: FFAccountHolderIdentity,
    accountsClosedCount: number,
    accountsActiveCount: number,
    accountsDelinquentCount: number,
    accountsTotalOutstanding: number,
    securedAccountsCount: number,
    securedAccountsClosedCount: number,
    securedAccountsActiveCount: number,
    securedAccountsDelinquentCount: number,
    securedAccountsTotalOutstanding: number,
    unsecuredAccountsCount: number,
    unsecuredAccountsClosedCount: number,
    unsecuredAccountsActiveCount: number,
    unsecuredAccountsDelinquentCount: number,
    unsecuredAccountsTotalOutstanding: number,
    unsecuredHDQ?: number,
    unsecuredHDQAccountNumber?: string,
    totalAccounts?: number,                             // for FE purpose
}


// interface's created to render HTML 
export interface PreprocessedData {
    ACTIVE: {
        SECURED: FFAccountInfo[];
        UNSECURED: FFAccountInfo[];
        OTHERS: FFAccountInfo[];
    };
    CLOSED: {
        CLOSED: FFAccountInfo[];
    };
}

export interface PreprocessedHistory {
  year: number;
  months: boolean[];
}